import { createFileRoute } from "@tanstack/react-router";
import { getGuide } from "@/data/guides";
import { GuidePage } from "@/components/site/GuidePage";
import { meta } from "@/lib/schema";
import { overviewKeywords } from "@/lib/localKeywords";

const guide = getGuide("woningontruiming-den-haag")!;

export const Route = createFileRoute("/woningontruiming-den-haag")({
  head: () =>
    meta({
      title: guide.seoTitle,
      description: guide.seoDescription,
      path: "/woningontruiming-den-haag",
      image: guide.image,
      keywords: overviewKeywords(guide.keywords),
    }),
  component: () => <GuidePage guide={guide} />,
});
